import { apiClient } from '@/lib/api-client';
import type { CollegeCreate, CollegeView, SchoolUpdate, School } from '@/types/api';

export const collegesService = {
  async createCollege(data: CollegeCreate): Promise<CollegeView> {
    const { data: college } = await apiClient.post<CollegeView>(
      '/v2/admin/colleges',
      data
    );
    return college;
  },

  async updateCollege(
    collegeId: string,
    schoolData: SchoolUpdate
  ): Promise<School> {
    const apiData: any = {
      school_id: collegeId,
    };

    if (schoolData.schoolTitle !== undefined) apiData.school_title = schoolData.schoolTitle;
    if (schoolData.status !== undefined) apiData.status = schoolData.status;
    if (schoolData.domains !== undefined) apiData.domains = schoolData.domains;
    if (schoolData.timezone !== undefined) apiData.timezone = schoolData.timezone;
    if (schoolData.state !== undefined) {
      apiData.state = schoolData.state;
      if (schoolData.country !== undefined) {
        apiData.country = schoolData.country;
      }
    }
    if (schoolData.country !== undefined) apiData.country = schoolData.country;
    if (schoolData.lat !== undefined) apiData.lat = schoolData.lat;
    if (schoolData.lng !== undefined) apiData.lng = schoolData.lng;
    if (schoolData.website !== undefined) apiData.website = schoolData.website;
    if (schoolData.studentsCount !== undefined) apiData.students_count = schoolData.studentsCount;
    if (schoolData.primaryColor !== undefined) apiData.primary_color = schoolData.primaryColor;
    if (schoolData.nickname !== undefined) apiData.nickname = schoolData.nickname;
    if (schoolData.private !== undefined) apiData.private = schoolData.private;
    if (schoolData.logoId !== undefined) apiData.mascot_id = schoolData.logoId;

    const { data } = await apiClient.patch<School>(
      '/v2/admin/colleges',
      apiData
    );
    return data;
  },

  async uploadMascot(file: File): Promise<{ id: string; url: string }> {
    const formData = new FormData();
    formData.append('file', file);

    const { data } = await apiClient.post<{ id: string; url: string }>(
      '/v2/media/school_logo',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return data;
  },
};
